
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
// Entities
import { User, Role, Lang } from "@/entities/index";

@Component
export default class UpdateUser extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop({ default: 0 }) myUserId!: number;
  @Prop({ default: () => ({}) }) user!: User;

  role = "";
  lang = "";

  @Watch("user", { immediate: true, deep: true })
  onUserChanged(newVal: User) {
    this.role = newVal.role || "";
    this.lang = newVal.lang || "";
  }

  roles: Role[] = [
    { text: "Standard", value: "standard" },
    { text: "Admin", value: "admin" },
  ];

  languages: Lang[] = [
    { text: "Français", value: "fr" },
    { text: "Anglais", value: "en" },
  ];

  // ========== CRUD ========== //

  updateUser(): void {
    this.$emit("update-user", {
      id: this.myUserId,
      role: this.role,
      lang: this.lang,
    });
    this.updateUserForm = false;
  }

  // ========== GETTERS & SETTERS ========== //

  get updateUserForm() {
    return this.value;
  }

  set updateUserForm(value: boolean) {
    this.$emit("input", value);
  }

  // ========== OTHER METHODS ========== //

  clear(): void {
    const btnClear = document.getElementById("btnClear");
    btnClear?.classList.add("clicked");
    setTimeout(() => {
      btnClear?.classList.remove("clicked");
    }, 500);

    this.role = "";
    this.lang = "";
  }
}
